import { useState } from 'react'

import { Button } from '../components/Button.js'
import styles from './Prompts.module.css'
import { useUnsavedWork } from './UnsavedWork.js'
import { useServiceWorker } from './ServiceWorkerProvider.js'

/**
 * Offers a downloaded update, and never while an editor is dirty.
 *
 * The deferral is the part that matters. A new version can land at any moment,
 * including mid-check-in, and applying it reloads the page — losing whatever
 * was typed. Waiting costs nothing: the worker is already downloaded and sits
 * there until asked.
 *
 * Declining is also honoured. The current version keeps running and the prompt
 * returns on the next launch; there is no countdown and no second nag.
 */
export function UpdatePrompt() {
  const { updateReady, applyUpdate } = useServiceWorker()
  const { hasUnsavedWork } = useUnsavedWork()
  const [dismissed, setDismissed] = useState(false)

  if (!updateReady || dismissed || hasUnsavedWork) {
    return null
  }

  return (
    <div className={styles['prompt']} role="status" aria-live="polite">
      <p className={styles['title']}>A new version is ready</p>
      <p className={styles['body']}>
        Updating reloads the app. Your data is stored on this device and is not affected.
      </p>
      <div className={styles['actions']}>
        <Button onClick={() => setDismissed(true)}>Not now</Button>
        <Button variant="primary" onClick={applyUpdate}>
          Update
        </Button>
      </div>
    </div>
  )
}
